export default "__VITE_ASSET__tNumljqt__"